// Typelizer digest e2a35bc24297aff7716e234981acf193
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /admin/weather/refresh */
  refresh: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/admin/weather/refresh', {}, options),
    method: 'post',
  }),

  /** GET /admin/weather */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/weather', {}, options),
    method: 'get',
  }),
}
